module.exports = __webpack_public_path__ + "static/media/product_4@3x.cd8d46cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/early_access/product_4/product_4@3x.png
// module id = 70
// module chunks = 0